import { useRef } from "react";

export function useSpeechToText(callback) {
  const recognitionRef = useRef(null);
  // Always hold a ref to the latest callback so the onresult handler
  // never captures a stale closure (listeningFor would be null otherwise).
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const startListening = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      return;
    }

    const recognition = new SpeechRecognition();

    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-US";

    recognition.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join(" ");
      callbackRef.current(transcript);
    };

    recognition.onend = () => {
      // Restart if not manually stopped
      if (recognitionRef.current) {
        recognition.start();
      }
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    };

    recognition.start();
    recognitionRef.current = recognition;
  };

  const stopListening = () => {
    const recognition = recognitionRef.current;
    if (recognition) {
      recognition.onend = null; // prevent auto-restart
      recognition.stop();
      recognitionRef.current = null;
    }
  };

  return { startListening, stopListening };
}
